export default __webpack_public_path__ + "static/media/SJA1380.34I-42028_-25249_0.153340f5.jpg";